var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1998 70.4H60.7998V57.6H67.1998V70.4ZM67.1998 83.2H60.7998V76.8H67.1998V83.2ZM28.7998 92.8H99.1998L63.9998 32L28.7998 92.8Z",
    fill: "#FDC246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningImage);
export default __webpack_public_path__ + "static/media/warningImage.191cc5aae148a073d986b015b3b3f9fb.svg";
export { ForwardRef as ReactComponent };